"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    aarstall: function() {
        return aarstall;
    },
    heltall: function() {
        return heltall;
    },
    positiveHeltall: function() {
        return positiveHeltall;
    },
    positiveDesimaltall: function() {
        return positiveDesimaltall;
    },
    tall0Til12: function() {
        return tall0Til12;
    },
    periodeMMYYYY: function() {
        return periodeMMYYYY;
    },
    maksLengdeForBeloep: function() {
        return maksLengdeForBeloep;
    },
    maksLengdeForBeloepForKraftOgPetroleum: function() {
        return maksLengdeForBeloepForKraftOgPetroleum;
    },
    maksLengdeForStortBeloep: function() {
        return maksLengdeForStortBeloep;
    },
    maksAntallDagerIAar: function() {
        return maksAntallDagerIAar;
    },
    obligatorisk: function() {
        return obligatorisk;
    },
    obligatoriskMedInnholdIListe: function() {
        return obligatoriskMedInnholdIListe;
    },
    huketAv: function() {
        return huketAv;
    },
    stoerreEnn0: function() {
        return stoerreEnn0;
    },
    maks4tegn: function() {
        return maks4tegn;
    },
    minMaks4tegn: function() {
        return minMaks4tegn;
    },
    maks10tegn: function() {
        return maks10tegn;
    },
    maks50tegn: function() {
        return maks50tegn;
    },
    maksTegn: function() {
        return maksTegn;
    },
    stoerreEllerLik10: function() {
        return stoerreEllerLik10;
    },
    fraOgMed0TilOgMed100: function() {
        return fraOgMed0TilOgMed100;
    },
    maks2Desimaltall: function() {
        return maks2Desimaltall;
    },
    maksHeltall: function() {
        return maksHeltall;
    },
    mindreEnnEllerLikDagerMellomToDatoer: function() {
        return mindreEnnEllerLikDagerMellomToDatoer;
    },
    maksDesimaltall: function() {
        return maksDesimaltall;
    },
    byggeaar: function() {
        return byggeaar;
    },
    aarsmodell: function() {
        return aarsmodell;
    },
    registreringsaar: function() {
        return registreringsaar;
    },
    heltallOgDesimaltall: function() {
        return heltallOgDesimaltall;
    },
    desimaltallStoerreEnnNullOgMindreEllerLikEn: function() {
        return desimaltallStoerreEnnNullOgMindreEllerLikEn;
    },
    validerProsent: function() {
        return validerProsent;
    },
    validerProsentHeltall: function() {
        return validerProsentHeltall;
    },
    vedleggPaakrevd: function() {
        return vedleggPaakrevd;
    },
    vedleggPaakrevdVedAvkrysningTrue: function() {
        return vedleggPaakrevdVedAvkrysningTrue;
    },
    vedleggPaakrevdVedAvkrysningFalse: function() {
        return vedleggPaakrevdVedAvkrysningFalse;
    },
    vedleggPaakrevdGitt: function() {
        return vedleggPaakrevdGitt;
    },
    fnr: function() {
        return fnr;
    },
    foedselsnr: function() {
        return foedselsnr;
    },
    organisasjonsnr: function() {
        return organisasjonsnr;
    },
    foedselsnrEllerOrganisasjonsnr: function() {
        return foedselsnrEllerOrganisasjonsnr;
    },
    minMaksBeloep: function() {
        return minMaksBeloep;
    },
    minMaksVerdi: function() {
        return minMaksVerdi;
    },
    nullEllerMinMaksBeloep: function() {
        return nullEllerMinMaksBeloep;
    },
    isinNummer: function() {
        return isinNummer;
    },
    maks12tegn: function() {
        return maks12tegn;
    },
    tilleggseiendom: function() {
        return tilleggseiendom;
    },
    maksEttKortPerPerson: function() {
        return maksEttKortPerPerson;
    },
    maksEttKortPerSaerskiltSkatteplikt: function() {
        return maksEttKortPerSaerskiltSkatteplikt;
    },
    maksEttKortPerFelt: function() {
        return maksEttKortPerFelt;
    },
    uniktFeltForSubforekomster: function() {
        return uniktFeltForSubforekomster;
    },
    dynamiskGruppeMaaHaInnhold: function() {
        return dynamiskGruppeMaaHaInnhold;
    },
    utleidArealOverHalveArealet: function() {
        return utleidArealOverHalveArealet;
    },
    sjablongberegnetFradragKnyttetTilBiomasseOgVedproduksjon: function() {
        return sjablongberegnetFradragKnyttetTilBiomasseOgVedproduksjon;
    },
    mindreEnnEllerLikFeltverdi: function() {
        return mindreEnnEllerLikFeltverdi;
    },
    likFeltverdi: function() {
        return likFeltverdi;
    },
    mindreEnnEllerLikAbsoluttFeltverdi: function() {
        return mindreEnnEllerLikAbsoluttFeltverdi;
    },
    minstEttFeltMaaFinnes: function() {
        return minstEttFeltMaaFinnes;
    },
    kildeskattepliktPaaPensjon: function() {
        return kildeskattepliktPaaPensjon;
    }
});
var _proptypes = /*#__PURE__*/ _interop_require_default(require("prop-types"));
var _get = /*#__PURE__*/ _interop_require_default(require("lodash/get"));
var _trim = /*#__PURE__*/ _interop_require_default(require("lodash/trim"));
var _uniq = /*#__PURE__*/ _interop_require_default(require("lodash/uniq"));
var _isPlainObject = /*#__PURE__*/ _interop_require_default(require("lodash/isPlainObject"));
var _utils = require("./utils");
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var aarstall = {
    navn: "\xc5rstall",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\d{0,4}$")),
    feilmelding: "feil.felt.aarstall",
    trigger: "tastetrykk"
};
var heltall = {
    navn: "Heltall",
    valider: _utils.erHeltall,
    feilmelding: "feil.felt.heltall",
    trigger: "tastetrykk"
};
var positiveHeltall = {
    navn: "Positive heltall",
    valider: _utils.erPositivtHeltall,
    feilmelding: "feil.felt.positiveHeltall",
    trigger: "tastetrykk",
    propTypes: {
        navn: _proptypes.default.string.isRequired
    }
};
var positiveDesimaltall = {
    navn: "Positive desimaltall",
    valider: function(verdi) {
        return heltallOgDesimaltall.valider(verdi) && (0, _utils.erPositivtHeltall)((0, _utils.getHeltallsDel)(verdi));
    },
    feilmelding: "feil.felt.positiveDesimaltall",
    trigger: "tastetrykk",
    propTypes: {
        navn: _proptypes.default.string.isRequired
    }
};
var tall0Til12 = {
    navn: "Heltall fra 1 til 12",
    valider: function(verdi) {
        return (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\d{0,2}$"))(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(0, 12))(verdi) && (0, _utils.firstTrue)(_utils.empty, _utils.isNumber)(verdi);
    },
    feilmelding: "feil.felt.tall0Til12",
    trigger: "tastetrykk"
};
var periodeMMYYYY = {
    navn: "Periode som m\xe5ned/\xe5r",
    valider: function(verdi) {
        return (0, _utils.isNull)(verdi) || (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^(0[1-9]|1[012])\\.(20[123][0-9])$"))(verdi);
    },
    feilmelding: "feil.felt.periodeMMYYYY",
    trigger: "tastetrykk"
};
var maksLengdeForBeloep = {
    navn: "Maks lengde for bel\xf8p som heltall",
    valider: function(verdi) {
        return (0, _utils.undefinedOrRegex)("^[+-]?.{0,13}$")((0, _utils.getHeltallsDel)(verdi));
    },
    feilmelding: "feil.felt.maksLengdeForBeloep",
    trigger: "tastetrykk"
};
var maksLengdeForBeloepForKraftOgPetroleum = {
    navn: "Maks lengde for bel\xf8p som heltall for kraft og petroleum",
    valider: function(verdi) {
        return (0, _utils.undefinedOrRegex)("^[+-]?.{0,15}$")((0, _utils.getHeltallsDel)(verdi));
    },
    feilmelding: "feil.felt.maksLengdeForBeloepForKraftOgPetroleum",
    trigger: "tastetrykk"
};
var maksLengdeForStortBeloep = {
    navn: "Maks lengde for bel\xf8p som heltall for store beloep",
    valider: function(verdi) {
        return (0, _utils.undefinedOrRegex)("^[+-]?.{0,30}$")((0, _utils.getHeltallsDel)(verdi));
    },
    feilmelding: "feil.felt.maksLengdeForStortBeloep",
    trigger: "tastetrykk"
};
var maksAntallDagerIAar = {
    navn: "Maks antall dager i inntekts\xe5r",
    valider: function valider(verdi, param) {
        var inntektsaar = param.inntektsaar;
        return (0, _utils.maxDagerIAar)(verdi, inntektsaar);
    },
    feilmelding: "feil.felt.maksAntallDagerIAar",
    inputs: [
        "inntektsaar"
    ],
    trigger: "tastetrykk"
};
var obligatorisk = {
    navn: "Obligatorisk",
    valider: function(verdi) {
        return verdi !== undefined && verdi !== null && (0, _trim.default)(verdi) !== "";
    },
    feilmelding: "feil.felt.obligatorisk",
    feltindikator: "*",
    trigger: "tastetrykk",
    visesAlltidISmia: true,
    propTypes: {
        navn: _proptypes.default.string.isRequired
    }
};
var obligatoriskMedInnholdIListe = {
    navn: "obligatoriskMedInnholdIListe",
    valider: function(verdi) {
        // verdi er subforekomst, ikke kjør validering
        if ((0, _isPlainObject.default)(verdi)) {
            return true;
        }
        return Array.isArray(verdi) && verdi.length > 0;
    },
    feilmelding: "feil.felt.obligatoriskMedInnholdIListe",
    feltindikator: "*",
    trigger: "trykkerOK",
    visesAlltidISmia: true
};
var huketAv = {
    navn: "Avkrysningsboks m\xe5 v\xe6re huket av",
    valider: function(verdi) {
        return verdi === true;
    },
    feilmelding: "feil.felt.avkrysningHuketAv",
    trigger: "trykkerOK",
    propTypes: {
        navn: _proptypes.default.string.isRequired,
        betingelse: _proptypes.default.object
    }
};
var stoerreEnn0 = {
    navn: "Verdi m\xe5 v\xe6re st\xf8rre enn 0",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.greaterOrEqualTo)(1)),
    feilmelding: "feil.felt.verdiStoerreEnn0",
    feltindikator: "*",
    trigger: "tastetrykk",
    visesAlltidISmia: true
};
var maks4tegn = {
    navn: "Maks 4 tegn",
    valider: (0, _utils.undefinedOrRegex)("^.{0,4}$"),
    feilmelding: "feil.felt.maks4tegn",
    trigger: "tastetrykk"
};
var minMaks4tegn = {
    navn: "Min Maks 4 tegn",
    valider: (0, _utils.undefinedOrRegex)("^.{4}$"),
    feilmelding: "feil.felt.minMaks4tegn",
    trigger: "fokustap"
};
var maks10tegn = {
    navn: "Maks 10 tegn",
    valider: (0, _utils.undefinedOrRegex)("^.{0,10}$"),
    feilmelding: "feil.felt.maks10tegn",
    trigger: "tastetrykk"
};
var maks50tegn = {
    navn: "Maks 50 tegn",
    valider: (0, _utils.undefinedOrRegex)("^.{0,50}$"),
    feilmelding: "feil.felt.maks50tegn",
    trigger: "tastetrykk"
};
var maksTegn = {
    navn: "Maks antall tegn",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var maks = args.maks;
        return (0, _utils.undefinedOrRegex)("^.{0," + maks + "}$")(verdi);
    },
    feilmelding: "feil.felt.maksTegn",
    trigger: "tastetrykk",
    args: [
        "maks"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            maks: _proptypes.default.number
        }).isRequired
    }
};
var stoerreEllerLik10 = {
    navn: "Minimumverdi 10",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.greaterOrEqualTo)(10)),
    feilmelding: "feil.felt.verdiMinst10",
    trigger: "fokustap"
};
var fraOgMed0TilOgMed100 = {
    navn: "Fra og med 0 til og med 100",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(0, 100)),
    feilmelding: "feil.felt.fraOgMed0TilOgMed100",
    trigger: "fokustap"
};
var maks2Desimaltall = {
    navn: "Maks 2 desimaltall",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\-?\\d+(\\.\\d{1,2})?(0*)?$")),
    feilmelding: "feil.felt.maks2Desimaltall",
    trigger: "fokustap"
};
var maksHeltall = {
    navn: "Maks antall heltallssiffer i tall",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var maks = args.maks;
        var localeVerdi = verdi !== undefined ? verdi.replace(",", ".") : verdi;
        return (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^[+-]?\\d{0," + maks + "}$"))((0, _utils.getHeltallsDel)(localeVerdi));
    },
    feilmelding: "feil.felt.maksHeltall",
    trigger: "tastetrykk",
    args: [
        "maks"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            maks: _proptypes.default.number
        }).isRequired
    }
};
var mindreEnnEllerLikDagerMellomToDatoer = {
    navn: "Feltet kan ikke ha st\xf8rre verdi enn antall dager som er igjen av \xe5ret",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var brukDefaultSluttdato = (0, _get.default)(kortdata, args.brukDefaultSluttdatoHvisFeltErTrue);
        var valgtStartdato = new Date((0, _get.default)(kortdata, args.referanseStartdato));
        var sluttdato = brukDefaultSluttdato ? args.defaultSluttdato : (0, _get.default)(kortdata, args.referanseSluttdato) || args.defaultSluttdato;
        var valgtSluttdato = new Date(sluttdato);
        var diffMs = valgtSluttdato - valgtStartdato;
        var diffDager = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
        return verdi <= diffDager;
    },
    feilmelding: "feil.felt.mindreEnnEllerLikDagerMellomToDatoer",
    trigger: "fokustap",
    args: [
        "referanseStartdato",
        "referanseSluttdato",
        "defaultSluttdato",
        "brukDefaultSluttdatoHvisFeltErTrue"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanseStartdato: _proptypes.default.string,
            referanseSluttdato: _proptypes.default.string
        }).isRequired
    }
};
var maksDesimaltall = {
    navn: "Maks antall desimaltallssiffer i tall",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var maks = args.maks;
        var localeVerdi = verdi !== undefined ? verdi.replace(",", ".") : verdi;
        return (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\d{0," + maks + "}$"))((0, _utils.getDesimaltallsDel)(localeVerdi));
    },
    feilmelding: "feil.felt.maksDesimaltall",
    trigger: "tastetrykk",
    args: [
        "maks"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            maks: _proptypes.default.number
        }).isRequired
    }
};
var byggeaar = {
    navn: "Bygge\xe5r",
    valider: function(verdi, param) {
        var inntektsaar = param.inntektsaar;
        return aarstall.valider(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(1250, inntektsaar))(verdi);
    },
    feilmelding: "feil.felt.byggeaar",
    inputs: [
        "inntektsaar"
    ],
    trigger: "fokustap"
};
var aarsmodell = {
    navn: "\xc5rsmodell",
    valider: function(verdi, param) {
        var inntektsaar = param.inntektsaar;
        return aarstall.valider(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.lessOrEqualTo)(inntektsaar + 1))(verdi);
    },
    feilmelding: "feil.felt.aarsmodell",
    inputs: [
        "inntektsaar"
    ],
    trigger: "fokustap"
};
var registreringsaar = {
    navn: "Registrerings\xe5r",
    valider: function(verdi, param) {
        var inntektsaar = param.inntektsaar;
        return aarstall.valider(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(1896, inntektsaar))(verdi);
    },
    feilmelding: "feil.felt.registreringsaar",
    inputs: [
        "inntektsaar"
    ],
    trigger: "fokustap"
};
var heltallOgDesimaltall = {
    navn: "Heltall og desimaltall",
    valider: function(verdi) {
        var localeVerdi = verdi !== undefined ? verdi.replace(",", ".") : verdi;
        return (0, _utils.firstTrue)(_utils.empty, _utils.isNumber)(localeVerdi) && (0, _utils.firstTrue)(_utils.empty, _utils.erHeltall)((0, _utils.getHeltallsDel)(localeVerdi));
    },
    feilmelding: "feil.felt.heltallOgDesimaltall",
    trigger: "tastetrykk"
};
var desimaltallStoerreEnnNullOgMindreEllerLikEn = {
    navn: "Desimaltall stoerre enn 0 og mindre eller lik en",
    valider: function(verdi) {
        var localeVerdi = verdi !== undefined ? verdi.replace(",", ".") : verdi;
        return (0, _utils.firstTrue)(_utils.empty, _utils.isNumber)(localeVerdi) && (0, _utils.firstTrue)(_utils.empty, _utils.erHeltall)((0, _utils.getHeltallsDel)(localeVerdi)) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.greaterThanAndLessOrEqual)(0, 1))(localeVerdi);
    },
    feilmelding: "feil.felt.desimaltallStoerreEnnNullOgMindreEllerLikEn",
    trigger: "tastetrykk"
};
var validerProsent = {
    navn: "Tall mellom 0 og 100, med maks 2 desimaler",
    valider: function(verdi) {
        var localeVerdi = verdi !== undefined ? verdi.replace(",", ".") : verdi;
        return (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\d+(\\.\\d{0,2})?$"))(localeVerdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(0, 100))(localeVerdi) && (0, _utils.firstTrue)(_utils.empty, _utils.isNumber)(localeVerdi);
    },
    feilmelding: "feil.felt.prosent",
    trigger: "tastetrykk"
};
var validerProsentHeltall = {
    navn: "Heltall mellom 0 og 100",
    valider: function(verdi) {
        return (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^\\d{0,3}$"))(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.between)(0, 100))(verdi) && (0, _utils.firstTrue)(_utils.empty, _utils.isNumber)(verdi);
    },
    feilmelding: "feil.felt.prosentheltall",
    trigger: "tastetrykk"
};
var harFilvedlegg = function(vedleggLastetOppImellomlager, forekomst, felt, slettVedleggKoe, visningsdatastiFraVdotId) {
    return vedleggLastetOppImellomlager.some(function(vedlegg) {
        var _visningsdatastiFraVdotId_felt_id;
        var identifikator = forekomst.kobling_id && felt.erFraForekomstKobling ? forekomst.kobling_id : forekomst.id;
        return (vedlegg.feltReferanse === [
            forekomst.id,
            felt.id
        ].join(".") || vedlegg.feltReferanse === identifikator + "." + ((_visningsdatastiFraVdotId_felt_id = visningsdatastiFraVdotId[felt.id]) === null || _visningsdatastiFraVdotId_felt_id === void 0 ? void 0 : _visningsdatastiFraVdotId_felt_id.referanse)) && !slettVedleggKoe.includes(vedlegg.vedleggId);
    });
};
var vedleggPaakrevd = {
    navn: "Krav om vedlegg for felt",
    valider: function(verdi, param, felt, forekomst) {
        var _param_vedleggLastetOppImellomlager = param.vedleggLastetOppImellomlager, vedleggLastetOppImellomlager = _param_vedleggLastetOppImellomlager === void 0 ? [] : _param_vedleggLastetOppImellomlager, _param_slettVedleggKoe = param.slettVedleggKoe, slettVedleggKoe = _param_slettVedleggKoe === void 0 ? [] : _param_slettVedleggKoe, _param_visningsdatastiFraVdotId = param.visningsdatastiFraVdotId, visningsdatastiFraVdotId = _param_visningsdatastiFraVdotId === void 0 ? {} : _param_visningsdatastiFraVdotId;
        return harFilvedlegg(vedleggLastetOppImellomlager, forekomst, felt, slettVedleggKoe, visningsdatastiFraVdotId);
    },
    feilmelding: "feil.felt.vedleggPaakrevd",
    trigger: "trykkerOK",
    propTypes: {
        navn: _proptypes.default.string.isRequired
    }
};
var vedleggPaakrevdVedAvkrysning = function(verdiMatcher) {
    return {
        navn: "Krav om vedlegg ved avkrysning for checkboks",
        valider: function(verdi, param, felt, forekomst) {
            var _param_vedleggLastetOppImellomlager = param.vedleggLastetOppImellomlager, vedleggLastetOppImellomlager = _param_vedleggLastetOppImellomlager === void 0 ? [] : _param_vedleggLastetOppImellomlager, _param_slettVedleggKoe = param.slettVedleggKoe, slettVedleggKoe = _param_slettVedleggKoe === void 0 ? [] : _param_slettVedleggKoe, _param_visningsdatastiFraVdotId = param.visningsdatastiFraVdotId, visningsdatastiFraVdotId = _param_visningsdatastiFraVdotId === void 0 ? {} : _param_visningsdatastiFraVdotId;
            var manglerFilvedlegg = !harFilvedlegg(vedleggLastetOppImellomlager, forekomst, felt, slettVedleggKoe, visningsdatastiFraVdotId) && verdiMatcher(verdi);
            return !manglerFilvedlegg;
        },
        feilmelding: "feil.felt.vedleggPaakrevd",
        trigger: "trykkerOK",
        propTypes: {
            navn: _proptypes.default.string.isRequired
        }
    };
};
var vedleggPaakrevdVedAvkrysningTrue = vedleggPaakrevdVedAvkrysning(function(verdi) {
    return verdi === true;
});
var vedleggPaakrevdVedAvkrysningFalse = vedleggPaakrevdVedAvkrysning(function(verdi) {
    return verdi === false;
});
var vedleggPaakrevdGitt = {
    navn: "Krav om vedlegg for felt gitt",
    valider: function(verdi, param, felt, forekomst, visningsdata, args) {
        var _param_vedleggLastetOppImellomlager = param.vedleggLastetOppImellomlager, vedleggLastetOppImellomlager = _param_vedleggLastetOppImellomlager === void 0 ? [] : _param_vedleggLastetOppImellomlager, _param_slettVedleggKoe = param.slettVedleggKoe, slettVedleggKoe = _param_slettVedleggKoe === void 0 ? [] : _param_slettVedleggKoe, _param_visningsdatastiFraVdotId = param.visningsdatastiFraVdotId, visningsdatastiFraVdotId = _param_visningsdatastiFraVdotId === void 0 ? {} : _param_visningsdatastiFraVdotId;
        if (args.medVerdi !== undefined && args.medVerdi.includes((0, _get.default)(forekomst, args.referanse))) {
            return vedleggPaakrevd.valider(verdi, {
                vedleggLastetOppImellomlager: vedleggLastetOppImellomlager,
                slettVedleggKoe: slettVedleggKoe,
                visningsdatastiFraVdotId: visningsdatastiFraVdotId
            }, felt, forekomst);
        }
        if (args.harVerdi !== undefined) {
            var harVerdiErTrue = args.harVerdi === true;
            var harVerdiErFalse = args.harVerdi === false;
            var referanseHarVerdi = (0, _get.default)(forekomst, args.referanse, "") !== "";
            if (harVerdiErTrue && referanseHarVerdi || harVerdiErFalse && !referanseHarVerdi) {
                return vedleggPaakrevd.valider(verdi, {
                    vedleggLastetOppImellomlager: vedleggLastetOppImellomlager,
                    slettVedleggKoe: slettVedleggKoe,
                    visningsdatastiFraVdotId: visningsdatastiFraVdotId
                }, felt, forekomst);
            }
        }
        return true;
    },
    feilmelding: "feil.felt.vedleggPaakrevd",
    trigger: "trykkerOK",
    args: [
        "referanse",
        "medVerdi"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string,
            medVerdi: _proptypes.default.arrayOf(_proptypes.default.any)
        }).isRequired
    }
};
var fnr = {
    navn: "F\xf8dselsnummer < 12 sifre",
    valider: function(verdi) {
        if (!verdi) {
            return true;
        }
        var trimmetVerdi = verdi.trim();
        return (0, _utils.isNumber)(trimmetVerdi) && trimmetVerdi.length < 12 && trimmetVerdi.length > 5;
    },
    feilmelding: "feil.felt.fnr",
    trigger: "fokustap"
};
var foedselsnr = {
    navn: "F\xf8dselsnummer 11 sifre",
    valider: function(verdi) {
        if (!verdi) {
            return true;
        }
        return (0, _utils.validerFnr)(verdi);
    },
    feilmelding: "feil.felt.fnr.gyldig",
    trigger: "fokustap"
};
var organisasjonsnr = {
    navn: "Organisasjonsnummer 9 sifre",
    valider: function(verdi) {
        if (!verdi) {
            return true;
        }
        return (0, _utils.validerOrgnr)(verdi);
    },
    feilmelding: "feil.felt.orgnr.gyldig",
    trigger: "fokustap"
};
var foedselsnrEllerOrganisasjonsnr = {
    navn: "Enten f\xf8dselsnummer 11 sifre eller organisasjonsnummer 9 sifre ",
    valider: function(verdi) {
        return (0, _utils.firstTrue)(foedselsnr.valider, organisasjonsnr.valider)(verdi);
    },
    feilmelding: "feil.felt.fnrEllerOrgnr.gyldig",
    trigger: "fokustap"
};
var minMaksBeloep = {
    navn: "\xd8vre og/eller nedre bel\xf8psgrense",
    valider: function(verdi, ignore, felt, kortdata, visningsdata, args) {
        return (0, _utils.firstTrue)(_utils.empty, _utils.erNumerisk)(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.validerMinMaksBeloep)(args))(verdi);
    },
    feilmelding: "feil.felt.minMaksBeloep",
    trigger: "fokustap",
    args: [
        "min",
        "maks"
    ],
    propTypes: {
        navn: _proptypes.default.string.isRequired,
        args: _proptypes.default.shape({
            min: _utils.minErStoerreEnnMaks,
            maks: _proptypes.default.number
        }).isRequired
    }
};
var minMaksVerdi = {
    navn: "\xd8vre og/eller nedre verdigrense",
    valider: function(verdi, ignore, felt, kortdata, visningsdata, args) {
        return (0, _utils.firstTrue)(_utils.empty, _utils.erNumerisk)(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.validerMinMaksBeloep)(args))(verdi);
    },
    feilmelding: "feil.felt.minMaksVerdi",
    trigger: "fokustap",
    args: [
        "min",
        "maks"
    ],
    propTypes: {
        navn: _proptypes.default.string.isRequired,
        args: _proptypes.default.shape({
            min: _utils.minErStoerreEnnMaks,
            maks: _proptypes.default.number
        }).isRequired
    }
};
var nullEllerMinMaksBeloep = {
    navn: "Verdi m\xe5 v\xe6re 0 eller \xf8vre og/eller nedre bel\xf8psgrense",
    valider: function(verdi, ignore, felt, kortdata, visningsdata, args) {
        return (0, _utils.firstTrue)(_utils.empty, _utils.erNumeriskNull)(verdi) || (0, _utils.firstTrue)(_utils.empty, _utils.erNumerisk)(verdi) && (0, _utils.firstTrue)(_utils.empty, (0, _utils.validerMinMaksBeloep)(args))(verdi);
    },
    feilmelding: "feil.felt.nullEllerMinMaksBeloep",
    trigger: "fokustap",
    args: [
        "min",
        "maks"
    ],
    propTypes: {
        navn: _proptypes.default.string.isRequired,
        args: _proptypes.default.shape({
            min: _utils.minErStoerreEnnMaks,
            maks: _proptypes.default.number
        }).isRequired
    }
};
var isinNummer = {
    navn: "Isinnummer 12 tegn",
    valider: (0, _utils.firstTrue)(_utils.empty, (0, _utils.regex)("^[A-Z]{2}[0-9A-Z]{9}[0-9]{1}")),
    feilmelding: "feil.felt.isinnummer",
    trigger: "fokustap"
};
var maks12tegn = {
    navn: "Maks 12 tegn",
    valider: (0, _utils.undefinedOrRegex)("^.{0,12}$"),
    feilmelding: "feil.felt.maks12tegn",
    trigger: "tastetrykk"
};
var tilleggseiendom = {
    navn: "Tilleggseiendom krever at det finnes en eiendom fra f\xf8r (i visningsdata) som kan knyttes til",
    valider: function(verdi, param, felt, kortdata, visningsdata) {
        var inntektsaar = param.inntektsaar, tekniskInntektsaar = param.tekniskInntektsaar;
        return !(verdi === _utils.TILLEGGSEIENDOM && (0, _utils.tilleggseiendomUtenFormuesobjekt)(visningsdata, kortdata, tekniskInntektsaar || inntektsaar));
    },
    feilmelding: "feil.eiendom.tilleggseiendomUtenFormuesobjekt",
    trigger: "trykkerOK"
};
var maksEttKortPerPerson = {
    navn: "Korttypen kan ha maks ett kort per person",
    valider: function(verdi, valideringsstate, kortdefinisjon, kortdata, visningsdata) {
        return !(0, _utils.harAnnetKortMedSammeFeltverdi)(kortdata, visningsdata, kortdefinisjon, "overfoertFraFoedselsnummer");
    },
    feilmelding: "feil.kort.maksEttKortPerPerson",
    trigger: "trykkerOK"
};
var maksEttKortPerSaerskiltSkatteplikt = {
    navn: "Korttypen kan ha maks ett kort per s\xe6rskilt skatteplikt",
    valider: function(verdi, valideringsstate, kortdefinisjon, kortdata, visningsdata) {
        return !(0, _utils.harAnnetKortMedSammeFeltverdiForOpsjon)(kortdata, visningsdata, kortdefinisjon.referanse, "saerskiltSkatteplikt");
    },
    feilmelding: "feil.kort.maksEttKortPerSaerskiltSkatteplikt",
    trigger: "trykkerOK"
};
var maksEttKortPerFelt = {
    navn: "Feltverdien kan bare brukes p\xe5 ett kort",
    valider: function(_, valideringsstate, felt, kortdata, visningsdata, args) {
        if (args.gjelderVerdier && !args.gjelderVerdier.includes(kortdata[felt.referanse])) {
            return true;
        }
        return !(0, _utils.harAnnetKortMedSammeFeltverdiForOpsjon)(kortdata, visningsdata, args.kortreferanse, felt.referanse);
    },
    feilmelding: "feil.felt.maksEttKortPerFelt",
    trigger: "fokustap",
    // Vi har ikke tilgang til kortdefinisjon i valideringen, så vi må legge ved kortreferanse
    args: [
        "kortreferanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            kortreferanse: _proptypes.default.string,
            gjelderVerdier: _proptypes.default.arrayOf(_proptypes.default.string)
        }).isRequired
    }
};
var uniktFeltForSubforekomster = {
    navn: "Subforekomster m\xe5 ha unik verdi for gitt felt",
    valider: function(verdi, valideringsstate, repeterendefelt, kortdata, visningsdata, args) {
        if (!Array.isArray(verdi)) {
            return true;
        }
        var verdier = verdi.map(function(subforekomst) {
            return (0, _get.default)(subforekomst, args.referanse, "");
        }).filter(function(verdi) {
            return !!verdi;
        });
        var unikeVerdier = (0, _uniq.default)(verdier);
        return verdier.length === unikeVerdier.length;
    },
    feilmelding: "feil.repeterendefelt.uniktFeltForSubforekomster",
    trigger: "trykkerOK",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var dynamiskGruppeMaaHaInnhold = {
    navn: "Dynamisk gruppe m\xe5 ha innhold",
    valider: function(verdi, valideringsstate, dynamiskgruppe, kortdata, visningsdata, args) {
        var subforekomster = (0, _get.default)(kortdata, dynamiskgruppe.referanse, []);
        var harVerdiForFeltreferanse = function(forekomst) {
            return (0, _get.default)(forekomst, args.referanse, "") !== "";
        };
        return subforekomster.some(harVerdiForFeltreferanse);
    },
    feilmelding: "feil.dynamiskGruppe.dynamiskGruppeMaaHaInnhold",
    trigger: "fokustap",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var utleidArealOverHalveArealet = {
    navn: "Utleid areal m\xe5 v\xe6re over 50 % av eiendommens areal",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var areal = parseInt((0, _get.default)(kortdata, args.arealReferanse));
        var verdiSomTall = parseInt(verdi);
        return verdiSomTall < areal && verdiSomTall > areal / 2;
    },
    feilmelding: "feil.felt.utleidArealOverHalveArealet",
    trigger: "fokustap",
    args: [
        "arealReferanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            arealReferanse: _proptypes.default.string
        }).isRequired
    }
};
var sjablongberegnetFradragKnyttetTilBiomasseOgVedproduksjon = {
    navn: "Sjablongberegnet fradrag for biomasse- og vedproduksjon kan maks utgj\xf8re 55 % av inntekter fra salg og uttak av ved og biomasse",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var salgsinntektOgUttakAvVedOgBiomasse = parseInt((0, _get.default)(kortdata, args.referanse));
        var verdiSomTall = parseInt(verdi);
        return !verdiSomTall || verdiSomTall <= salgsinntektOgUttakAvVedOgBiomasse * 0.55;
    },
    feilmelding: "feil.felt.sjablongberegnetFradragKnyttetTilBiomasseOgVedproduksjon",
    trigger: "fokustap",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var mindreEnnEllerLikFeltverdi = {
    navn: "Feltet kan ikke ha st\xf8rre verdi enn verdien i et annet gitt felt",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var referanseverdi = parseInt((0, _get.default)(kortdata, args.referanse));
        var verdiSomTall = parseInt(verdi);
        return (0, _utils.empty)(verdi) || verdiSomTall <= referanseverdi;
    },
    feilmelding: "feil.felt.mindreEnnEllerLikFeltverdi",
    trigger: "fokustap",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var likFeltverdi = {
    navn: "Feltet m\xe5 ha samme verdi som verdien i et annet gitt felt",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var referanseverdi = parseInt((0, _get.default)(kortdata, args.referanse));
        var verdiSomTall = parseInt(verdi);
        return verdiSomTall === referanseverdi;
    },
    feilmelding: "feil.felt.likFeltverdi",
    trigger: "fokustap",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var mindreEnnEllerLikAbsoluttFeltverdi = {
    navn: "Feltet kan ikke ha st\xf8rre verdi enn den absolutte verdien i et annet gitt felt",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var referanseverdi = Math.abs(parseInt((0, _get.default)(kortdata, args.referanse)));
        var verdiSomTall = parseInt(verdi);
        return (0, _utils.empty)(verdi) || verdiSomTall <= referanseverdi;
    },
    feilmelding: "feil.felt.mindreEnnEllerLikAbsoluttFeltverdi",
    trigger: "fokustap",
    args: [
        "referanse"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanse: _proptypes.default.string
        }).isRequired
    }
};
var minstEttFeltMaaFinnes = {
    navn: "Minst ett av f\xf8lgende felt m\xe5 ha en verdi p\xe5 kortet",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        var harVerdi = function(verdi) {
            return verdi !== undefined && verdi !== null && (0, _trim.default)(verdi) !== "";
        };
        return args.referanser.some(function(felt) {
            return harVerdi((0, _get.default)(kortdata, felt));
        });
    },
    feilmelding: "feil.kort.minstEttFeltMaaFinnes",
    trigger: "trykkerOK",
    args: [
        "referanser"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            referanser: _proptypes.default.arrayOf(_proptypes.default.string)
        }).isRequired
    }
};
var kildeskattepliktPaaPensjon = {
    navn: "KPP m\xe5 ha gyldig trygde- eller skattemessig unntak",
    valider: function(verdi, valideringsstate, felt, kortdata, visningsdata, args) {
        if (kortdata.saerskiltSkatteplikt !== "kildeskattepliktPaaPensjon") {
            return true;
        }
        if (!args.pensjonstyper.includes(kortdata.pensjonstype)) {
            return true;
        }
        var harGyldigTrygdeEllerSkattemessigUnntak = function(felt) {
            return [
                "skattepliktigKildeskattPaaPensjon",
                "skattefriKildeskattPaaPensjon"
            ].includes(felt.trygdeEllerSkattemessigUnntak);
        };
        return [
            kortdata.sumPensjonsinntektForAaret
        ].concat(_to_consumable_array((kortdata.pensjonsinntektPerMaaned || []).map(function(felt) {
            return felt.pensjonsinntekt;
        }))).filter(function(felt) {
            return !!felt;
        }).every(function(felt) {
            return !!felt.beloepIValuta && harGyldigTrygdeEllerSkattemessigUnntak(felt);
        });
    },
    feilmelding: "feil.kort.kildeskattepliktPaaPensjon",
    trigger: "trykkerOK",
    args: [
        "pensjonstyper"
    ],
    propTypes: {
        args: _proptypes.default.shape({
            pensjonstyper: _proptypes.default.arrayOf(_proptypes.default.string)
        }).isRequired
    }
};
